import FundProvider from "./FundProvider";

const fundProvider = {
  FundProvider
};

export default fundProvider;